/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Folders_SectionInputs */



/**
* | output |
* | --- |
* | "Folders" |
*
* @param {Explorer_Thumbnail_Folders_SectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_folders_section = /** @type {((inputs?: Explorer_Thumbnail_Folders_SectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Folders_SectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dossiers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cartelle")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Папки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carpetas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pastas")
	return /** @type {LocalizedString} */ ("Folders")
});